/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const AccountDetailsPropTypes = {
  /**
   * The JSS classes to use
   */
  account: PropTypes.object.isRequired,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,
};

export default AccountDetailsPropTypes;
